import { Field, useFormikContext } from 'formik';
import _ from 'lodash';
import { useRef } from 'react';
import { FormFeedback } from 'reactstrap';
import StandardTypeahead from './basics/StandardTypeahead';

const MultiTypeahead = ({ name, closeMenuOnBlur = true, ...props }) => {
  const ref = useRef();
  const { setFieldValue, values } = useFormikContext();
  return (
    <StandardTypeahead
      closeMenuOnBlur={closeMenuOnBlur}
      multiple
      onChange={(value) => {
        if (!closeMenuOnBlur) ref.current.toggleMenu(true);
        setFieldValue(name, value);
      }}
      ref={ref}
      selected={values[name] || []}
      {...props}
    />
  );
};

const SingleTypeahead = ({ name, placeholder, labelKey, ...props }) => {
  const { setFieldValue, setFieldTouched, values } = useFormikContext();
  const selected = _.get(values, name);
  const selectedDisplay = labelKey ? _.get(selected, labelKey) : selected;

  return (
    <StandardTypeahead
      labelKey={labelKey}
      onChange={([value] = []) => {
        setFieldValue(name, value);
        setFieldTouched(name, true);
      }}
      placeholder={selectedDisplay || placeholder || 'Select...'}
      {...props}
    />
  );
};

const FormTypeahead = ({ name, multiple, ...props }) => {
  const TypeaheadComponent = multiple ? MultiTypeahead : SingleTypeahead;
  return (
    <Field name={name}>
      {({ meta: { touched, error } }) => {
        return (
          <>
            <TypeaheadComponent
              {...props}
              isInvalid={!!(touched && error)}
              name={name}
            />
            {touched && error && (
              <FormFeedback className="d-block">{error}</FormFeedback>
            )}
          </>
        );
      }}
    </Field>
  );
};

export default FormTypeahead;
